export default function getLocalLineId(
    trackLocalId: string,
    fromPoint: TrackPoint | undefined,
    toPoint: TrackPoint | undefined
) {
    return [
        trackLocalId,
        fromPoint && fromPoint.properties.pointLocalId,
        toPoint && toPoint.properties.pointLocalId,
    ].join('__');
}
